export default function LegalLayout({ title, updated, intro, sections }) {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <div className="mb-12">
        <h1 className="font-display-lg uppercase text-3xl md:text-4xl mb-3">{title}</h1>
        <p className="font-mono-brand text-[11px] text-[#7d7d8c] uppercase tracking-widest">Last updated: {updated}</p>
        {intro && <p className="text-sm text-[#888899] mt-5 max-w-2xl leading-relaxed">{intro}</p>}
      </div>

      <div className="flex flex-col md:flex-row gap-12">
        <nav className="md:w-56 flex-shrink-0 md:sticky md:top-24 self-start">
          <div className="font-mono-brand text-[10px] text-[#7d7d8c] uppercase tracking-widest mb-3">On this page</div>
          <ol className="flex flex-col gap-2 text-sm">
            {sections.map((s, i) => (
              <li key={s.id}>
                <a href={`#${s.id}`} className="text-[#888899] hover:text-[#ff544a] transition-colors">
                  <span className="font-mono-brand text-[#7d7d8c] mr-1.5">{String(i + 1).padStart(2, '0')}</span>
                  {s.heading}
                </a>
              </li>
            ))}
          </ol>
        </nav>

        <div className="flex-1 min-w-0 flex flex-col gap-10">
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} className="scroll-mt-24 pb-8 border-b border-[#1e1e28] last:border-0">
              <h2 className="text-lg font-bold text-white mb-3 flex items-baseline gap-2">
                <span className="font-mono-brand text-sm text-[#ff544a]">{String(i + 1).padStart(2, '0')}</span>
                {s.heading}
              </h2>
              <div className="text-sm text-[#c9c9d6] leading-relaxed flex flex-col gap-3">{s.body}</div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
